import { isMobileScreen } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHourglassHalf } from '@fortawesome/free-regular-svg-icons';
import { faArrowCircleDown } from '@fortawesome/free-solid-svg-icons';
import { FileApi } from '@apply/api';
import { applicationInsights } from '../../../../../../../../ApplicationInsights';
import { Button, ButtonTheme } from '@apply/components';

export interface ICCACellProps {
    iccaDownloadToken: string | undefined;
    generatingIccaPdfUrl: string | undefined;
    onRefreshGrid: (e: React.MouseEvent<HTMLButtonElement>) => void | Promise<void>;
}

export const ICCACell: React.FC<ICCACellProps> = ({ iccaDownloadToken, generatingIccaPdfUrl, onRefreshGrid }) => {
    const mobileScreen = isMobileScreen();
    const fileApi = new FileApi.FileApi(applicationInsights);
    const hasIcca = Boolean(iccaDownloadToken || generatingIccaPdfUrl);

    const _downloadIcca = async (iccaDownloadToken: string) => {
        const response = await fileApi.downloadUrl({
            token: iccaDownloadToken,
        });

        if (response.statusCode !== 200) return;
        window.location.href = response.result.downloadUrl;
    };

    const iccaCellValue = () => {
        return (
            <>
                {iccaDownloadToken && !generatingIccaPdfUrl && (
                    <Button
                        id='downloadICCAButton'
                        theme={ButtonTheme.Tertiary}
                        width='115px'
                        height='24px'
                        handleClick={() => _downloadIcca(iccaDownloadToken)}
                    >
                        <FontAwesomeIcon
                            icon={faArrowCircleDown}
                            style={{ paddingRight: '5px', paddingBottom: '2px' }}
                        />
                        Download
                    </Button>
                )}
                {generatingIccaPdfUrl && (
                    <span
                        style={{
                            color: 'black',
                            width: '30px',
                            textAlign: 'center',
                            display: 'inline-block',
                        }}
                        onClick={(e) => onRefreshGrid(e)}
                    >
                        <FontAwesomeIcon
                            title='ICCA PDF is generating...'
                            icon={faHourglassHalf}
                        />
                    </span>
                )}
            </>
        );
    };

    return hasIcca ? (
        <>
            <div className={`activatedBrokerReferralsTable-icca ${mobileScreen ? 'mobile' : ''}`}>
                <div className='activatedBrokerReferralsTable-icca-value'>{iccaCellValue()}</div>
            </div>
        </>
    ) : null;
};
